import { PolygonPatternCustomLayer } from '@pn/services/map/mapbox/custom/PolygonPatternCustomLayer';

/**
 * Registry for all custom layers added to the PN map.
 */
export const customLayersRegistry: Map<string, PolygonPatternCustomLayer> =
  new Map();
